import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
    >
      <path fill="none" d="M0 0H256V256H0z" />
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
        d="M122.7 25.9L42 42l-16.1 80.7a8 8 0 002.2 7.2l104.4 104.4a7.9 7.9 0 0011.3 0l90.5-90.5a7.9 7.9 0 000-11.3L129.9 28.1a8 8 0 00-7.2-2.2z"
      />
      <circle cx="84" cy="84" r="12" />
    </svg>
  );
}

export default Icon;
